import { useRouter } from 'next/router';
import { getBCP47Language, getSafeLocale, getSafeLocaleForSanity } from 'shared/utils/locale';

export function useLocale() {
  const router = useRouter();
  return getSafeLocale(router.locale);
}

export function useLocaleForSanity() {
  const router = useRouter();
  return getSafeLocaleForSanity(router.locale);
}

export function useBCP47Locale() {
  const locale = useLocale();
  return getBCP47Language(locale);
}
